const wrapActions = ({
  dispatch,
  actions
}) => {
  return Object.keys(actions).reduce((acc, key) => Object.assign(Object.assign({}, acc), {
    [key]: actions[key](dispatch)
  }),
  // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
  {});
};
const filterValues = (values, allowed) => {
  if (!values) {
    return values;
  }
  const allowedKeys = Object.keys(allowed);
  return Object.keys(values).filter(key => allowedKeys.includes(key)).reduce((acc, key) => Object.assign(Object.assign({}, acc), {
    [key]: values[key]
  }), {});
};
const getPropertyFromPayload = (propName, payload) => {
  if (propName in payload && (payload === null || payload === void 0 ? void 0 : payload[propName]) !== undefined) {
    return payload === null || payload === void 0 ? void 0 : payload[propName];
  }
  return undefined;
};
export { wrapActions, filterValues, getPropertyFromPayload };